'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {PassReminderCtrl} from "./passreminderctrl.js";
EwSiteApp.controller('PassReminderCtrl', ["$scope", "jsDataService", "notify", "pageProgress", PassReminderCtrl]);
